import { css } from '@emotion/react';

import { COLORS } from '~/styles/colors';

export const useStyles = ({ primaryColor, secondaryColor, textsColor, isCouponSide, textsFontFamily }) => {
  return {
    frontTop: css`
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      gap: 8px;
    `,
    container: css`
      padding: 0 10px;
    `,
    topCard: css`
      position: relative;
      border-bottom: 1px dashed ${COLORS.grey400};
      background-color: ${COLORS.white};
      border-radius: 10px 10px 0 0;
      min-height: 310px;
      display: flex;
      flex-direction: column;
      padding: ${isCouponSide ? '0 12px 12px' : 0};

      &:before,
      &:after {
        position: absolute;
        content: '';
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background-color: ${primaryColor};
        bottom: 0;
      }

      &:before {
        left: 0;
        transform: translate(-50%, 50%);
      }

      &:after {
        right: 0;
        transform: translate(50%, 50%);
      }

      .termsBtn {
        all: unset;
        margin: 24px auto 0;
        cursor: pointer;
        font-size: 11.5px;
        font-weight: 500;
        color: ${COLORS.textMain};
        text-decoration: underline;
        font-family: ${textsFontFamily};
      }

      .barcodeImage {
        margin-top: 24px;
      }
    `,
    bottomCard: css`
      background-color: ${COLORS.white};
      border-radius: 0 0 10px 10px;
      padding: 28px 12px 16px;

      a.couponButtonText {
        background-color: ${secondaryColor};
        color: ${textsColor};
        border-radius: 64px;
        padding: 10px 14px;
        font-size: 18px;
        font-weight: 600;
        line-height: 25px;
        width: 100%;
        display: block;
        text-decoration: none;
        text-align: center;
        font-family: ${textsFontFamily};
        word-break: break-word;
      }

      a.seeLocationLink {
        border: 1px solid ${secondaryColor};
        color: ${COLORS.textMain};
        font-size: 18px;
        font-weight: 600;
        background-color: ${COLORS.white};
        border-radius: 64px;
        padding: 10px 13px;
        line-height: 25px;
        width: 100%;
        text-decoration: none;
        display: block;
        text-align: center;
        margin-top: 6px;
        font-family: ${textsFontFamily};
      }
    `,
    bottomButton: css`
      background-color: ${secondaryColor};
      color: ${textsColor};
      border-radius: 64px;
      padding: 10px 14px;
      font-size: 18px;
      font-weight: 600;
      line-height: 25px;
      width: 100%;
      text-transform: none;
      box-shadow: none;
      font-family: ${textsFontFamily};
      word-break: break-word;

      &:hover {
        background-color: ${secondaryColor};
        box-shadow: none;
      }
    `,
    frontSideContent: css`
      display: flex;
      flex-direction: column;
      flex: 1;
    `,
    frontSideTop: css`
      flex: 1;
      min-height: 155px;
      max-height: 155px;
      position: relative;

      img {
        object-fit: cover;
        max-height: 155px;
        border-radius: 10px 10px 0 0;
      }
    `,
    frontSideBottom: css`
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 7px;
      padding: 0 12px 16px;
      justify-content: center;
      align-items: center;
    `,
    salesBadge: css`
      background-color: ${primaryColor};
      border-radius: 12px;
      position: absolute;
      bottom: 0;
      transform: translateY(50%);
      right: 12px;
      padding: 6px 12px;
      max-width: calc(100% - 24px);
    `,
    copyCode: css`
      font-size: 9.65px;
      margin: 0 auto;
      padding: 2px;
      text-decoration: underline;
      color: ${COLORS.primary};
      text-transform: none;
      font-family: ${textsFontFamily};

      &:hover {
        text-decoration: underline;
        background: none;
      }
    `,
    backToFront: css`
      width: fit-content;
      padding: 8px 8px 8px 0;
    `,
    termsAndConditionsBlock: css`
      margin-top: 20px;
    `,
  };
};
